@if (isAuthenticated()) {
  <div>
    <br>
      <hr>
        <div class="text-center">
          <a href="{{ this.pS.portalMod()['footer'] }}" target="_blank">{{ this.pS.portalMod()['footerName'] }}</a>
        </div>
        <br>
        </div>
      }